/**
 * Kontotyp "Nur lesen" in der Oberflaeche: hat dieses Konto irgendein Schreibrecht?
 *
 * Der Client rechnet nicht von der Rolle zu Rechten (die Rechte kommen fertig von `GET /api/auth/me`, siehe
 * `state/rechteMatrix.ts`), sondern fragt die Rechte selbst: ein Konto ist "nur lesen", wenn kein einziges
 * Recht mit einem anderen Praefix als `view_` darin steht. Das trifft genau `read_only` (die fuenf `view_*`)
 * und nichts, was heute schon schreiben darf - `payment_manager` fuehrt `manage_payments`, `manage_fx` und
 * `delete_jtl_order` und ist deshalb KEIN Nur-Leser, auch ohne `edit_orders`.
 *
 * Ein LEERES Set gilt als Nur-Leser: vor dem Laden von `/api/auth/me` ist noch kein Recht bekannt, und
 * die Bearbeiten-Moeglichkeiten erscheinen erst mit den Rechten statt kurz zu blitzen und dann zu scheitern
 * ("Dein Konto hat nur Leserechte.", der Schreibriegel des Servers).
 *
 * Die Datei liegt neben `berechtigungen.ts` und nicht darin: jene wird wortgleich gegen `index.html`
 * gehalten (`test/parity/berechtigungen.test.ts`), der Bestand kennt den Kontotyp nicht.
 */
export function istNurLeser(rechte: ReadonlySet<string>): boolean {
  for (const recht of rechte) {
    if (!recht.startsWith("view_")) return false;
  }
  return true;
}
